
export interface ViewModel {
  password: string;
  repeatedPassword: string;
}

export const viewModelNewValues: ViewModel = {
  password: "",
  repeatedPassword: ""
}